export const twMergeConfig = {
  "extend": {
    "theme": {
      "borderWidth": [
        "thin",
        "none",
        "",
        "thick"
      ],
      "borderRadius": [
        "none",
        "button",
        "control",
        "container-xs",
        "container-sm",
        "container-md",
        "container-lg"
      ],
      "colors": [
        "neutral-primary",
        "neutral-primary-invert",
        "neutral-secondary",
        "neutral-tertiary",
        "disabled",
        "neutral-quaternary",
        "brand-accent",
        "comp-high-contrast",
        "comp-high-contrast-invert",
        "comp-high-contrast-on-dark",
        "comp-high-contrast-on-light",
        "comp-high-contrast-hover",
        "comp-high-contrast-pressed",
        "brand-accent-invert",
        "brand-accent-on-dark",
        "brand-highlight",
        "validation-danger",
        "validation-danger-on-light",
        "validation-success",
        "validation-success-on-light",
        "validation-informative",
        "validation-informative-on-light",
        "validation-warning"
      ],
      "backgroundColor": [
        "neutral-primary",
        "neutral-primary-elevated",
        "neutral-primary-invert",
        "neutral-secondary",
        "neutral-secondary-invert",
        "neutral-tertiary",
        "neutral-quaternary",
        "neutral-quaternary-invert",
        "neutral-tertiary-invert",
        "neutral-overlay",
        "neutral-overlay-strong",
        "brand-accent",
        "brand-accent-invert-on-dark",
        "brand-accent-invert",
        "brand-tint",
        "brand-highlight",
        "comp-primary-light",
        "comp-primary-dark",
        "comp-secondary-light",
        "comp-secondary-dark",
        "comp-accent-hover",
        "comp-accent-invert-hover",
        "comp-accent-pressed",
        "comp-accent-invert-pressed",
        "comp-primary-hover",
        "comp-primary-elevated-hover",
        "comp-primary-pressed",
        "comp-primary-elevated-pressed",
        "comp-primary-ghost",
        "comp-secondary-hover",
        "comp-secondary-pressed",
        "comp-invert-hover",
        "comp-invert-pressed",
        "comp-ghost",
        "comp-ghost-hover",
        "comp-ghost-pressed",
        "page-primary",
        "page-primary-dark",
        "page-secondary",
        "page-tertiary",
        "page-tint",
        "disabled",
        "disabled-elevated",
        "validation-danger-light",
        "validation-danger-bold",
        "validation-success-light",
        "validation-success-bold",
        "validation-warning-light",
        "validation-warning-bold",
        "validation-informative-light",
        "validation-informative-bold"
      ],
      "borderColor": [
        "neutral-strong",
        "neutral-strong-invert",
        "neutral-strong-on-dark",
        "neutral-strong-on-light",
        "neutral-subtlest",
        "neutral-subtle",
        "neutral-default",
        "brand-accent",
        "brand-accent-invert",
        "brand-accent-on-dark",
        "brand-accent-alpha-default",
        "disabled",
        "focus",
        "validation-danger",
        "validation-success",
        "validation-warning",
        "validation-informative"
      ],
      "outlineColor": [
        "neutral-strong",
        "neutral-strong-invert",
        "neutral-strong-on-dark",
        "neutral-strong-on-light",
        "neutral-subtlest",
        "neutral-subtle",
        "neutral-default",
        "brand-accent",
        "brand-accent-invert",
        "brand-accent-on-dark",
        "brand-accent-alpha-default",
        "disabled",
        "focus",
        "validation-danger",
        "validation-success",
        "validation-warning",
        "validation-informative"
      ],
      "ringColor": [
        "neutral-primary",
        "neutral-primary-elevated",
        "neutral-primary-invert",
        "neutral-secondary",
        "neutral-secondary-invert",
        "neutral-tertiary",
        "neutral-quaternary",
        "neutral-quaternary-invert",
        "neutral-tertiary-invert",
        "neutral-overlay",
        "neutral-overlay-strong",
        "brand-accent",
        "brand-accent-invert-on-dark",
        "brand-accent-invert",
        "brand-tint",
        "brand-highlight",
        "comp-primary-light",
        "comp-primary-dark",
        "comp-secondary-light",
        "comp-secondary-dark",
        "comp-accent-hover",
        "comp-accent-invert-hover",
        "comp-accent-pressed",
        "comp-accent-invert-pressed",
        "comp-primary-hover",
        "comp-primary-elevated-hover",
        "comp-primary-pressed",
        "comp-primary-elevated-pressed",
        "comp-primary-ghost",
        "comp-secondary-hover",
        "comp-secondary-pressed",
        "comp-invert-hover",
        "comp-invert-pressed",
        "comp-ghost",
        "comp-ghost-hover",
        "comp-ghost-pressed",
        "page-primary",
        "page-primary-dark",
        "page-secondary",
        "page-tertiary",
        "page-tint",
        "disabled",
        "disabled-elevated",
        "validation-danger-light",
        "validation-danger-bold",
        "validation-success-light",
        "validation-success-bold",
        "validation-warning-light",
        "validation-warning-bold",
        "validation-informative-light",
        "validation-informative-bold"
      ],
      "gradientColorStops": [
        "from-neutral-primary",
        "to-neutral-primary",
        "via-neutral-primary",
        "from-neutral-primary-elevated",
        "to-neutral-primary-elevated",
        "via-neutral-primary-elevated",
        "from-neutral-primary-invert",
        "to-neutral-primary-invert",
        "via-neutral-primary-invert",
        "from-neutral-secondary",
        "to-neutral-secondary",
        "via-neutral-secondary",
        "from-neutral-secondary-invert",
        "to-neutral-secondary-invert",
        "via-neutral-secondary-invert",
        "from-neutral-tertiary",
        "to-neutral-tertiary",
        "via-neutral-tertiary",
        "from-neutral-quaternary",
        "to-neutral-quaternary",
        "via-neutral-quaternary",
        "from-neutral-quaternary-invert",
        "to-neutral-quaternary-invert",
        "via-neutral-quaternary-invert",
        "from-neutral-tertiary-invert",
        "to-neutral-tertiary-invert",
        "via-neutral-tertiary-invert",
        "from-neutral-overlay",
        "to-neutral-overlay",
        "via-neutral-overlay",
        "from-neutral-overlay-strong",
        "to-neutral-overlay-strong",
        "via-neutral-overlay-strong",
        "from-brand-accent",
        "to-brand-accent",
        "via-brand-accent",
        "from-brand-accent-invert-on-dark",
        "to-brand-accent-invert-on-dark",
        "via-brand-accent-invert-on-dark",
        "from-brand-accent-invert",
        "to-brand-accent-invert",
        "via-brand-accent-invert",
        "from-brand-tint",
        "to-brand-tint",
        "via-brand-tint",
        "from-brand-highlight",
        "to-brand-highlight",
        "via-brand-highlight",
        "from-comp-primary-light",
        "to-comp-primary-light",
        "via-comp-primary-light",
        "from-comp-primary-dark",
        "to-comp-primary-dark",
        "via-comp-primary-dark",
        "from-comp-secondary-light",
        "to-comp-secondary-light",
        "via-comp-secondary-light",
        "from-comp-secondary-dark",
        "to-comp-secondary-dark",
        "via-comp-secondary-dark",
        "from-comp-accent-hover",
        "to-comp-accent-hover",
        "via-comp-accent-hover",
        "from-comp-accent-invert-hover",
        "to-comp-accent-invert-hover",
        "via-comp-accent-invert-hover",
        "from-comp-accent-pressed",
        "to-comp-accent-pressed",
        "via-comp-accent-pressed",
        "from-comp-accent-invert-pressed",
        "to-comp-accent-invert-pressed",
        "via-comp-accent-invert-pressed",
        "from-comp-primary-hover",
        "to-comp-primary-hover",
        "via-comp-primary-hover",
        "from-comp-primary-elevated-hover",
        "to-comp-primary-elevated-hover",
        "via-comp-primary-elevated-hover",
        "from-comp-primary-pressed",
        "to-comp-primary-pressed",
        "via-comp-primary-pressed",
        "from-comp-primary-elevated-pressed",
        "to-comp-primary-elevated-pressed",
        "via-comp-primary-elevated-pressed",
        "from-comp-primary-ghost",
        "to-comp-primary-ghost",
        "via-comp-primary-ghost",
        "from-comp-secondary-hover",
        "to-comp-secondary-hover",
        "via-comp-secondary-hover",
        "from-comp-secondary-pressed",
        "to-comp-secondary-pressed",
        "via-comp-secondary-pressed",
        "from-comp-invert-hover",
        "to-comp-invert-hover",
        "via-comp-invert-hover",
        "from-comp-invert-pressed",
        "to-comp-invert-pressed",
        "via-comp-invert-pressed",
        "from-comp-ghost",
        "to-comp-ghost",
        "via-comp-ghost",
        "from-comp-ghost-hover",
        "to-comp-ghost-hover",
        "via-comp-ghost-hover",
        "from-comp-ghost-pressed",
        "to-comp-ghost-pressed",
        "via-comp-ghost-pressed",
        "from-page-primary",
        "to-page-primary",
        "via-page-primary",
        "from-page-primary-dark",
        "to-page-primary-dark",
        "via-page-primary-dark",
        "from-page-secondary",
        "to-page-secondary",
        "via-page-secondary",
        "from-page-tertiary",
        "to-page-tertiary",
        "via-page-tertiary",
        "from-page-tint",
        "to-page-tint",
        "via-page-tint",
        "from-disabled",
        "to-disabled",
        "via-disabled",
        "from-disabled-elevated",
        "to-disabled-elevated",
        "via-disabled-elevated",
        "from-validation-danger-light",
        "to-validation-danger-light",
        "via-validation-danger-light",
        "from-validation-danger-bold",
        "to-validation-danger-bold",
        "via-validation-danger-bold",
        "from-validation-success-light",
        "to-validation-success-light",
        "via-validation-success-light",
        "from-validation-success-bold",
        "to-validation-success-bold",
        "via-validation-success-bold",
        "from-validation-warning-light",
        "to-validation-warning-light",
        "via-validation-warning-light",
        "from-validation-warning-bold",
        "to-validation-warning-bold",
        "via-validation-warning-bold",
        "from-validation-informative-light",
        "to-validation-informative-light",
        "via-validation-informative-light",
        "from-validation-informative-bold",
        "to-validation-informative-bold",
        "via-validation-informative-bold"
      ],
      "fontSize": [
        "label-lg",
        "label-md",
        "heading-2xl",
        "paragraph-lg",
        "label-sm",
        "paragraph-md",
        "paragraph-sm",
        "paragraph-xs",
        "heading-xl",
        "heading-lg",
        "heading-md",
        "heading-sm",
        "heading-xs",
        "heading-2xs",
        "label-xs",
        "display-xl",
        "display-lg",
        "display-md",
        "display-sm",
        "display-xs",
        "display-xs-smaller",
        "display-2xs",
        "display-label-lg",
        "display-label-md",
        "display-label-sm"
      ],
      "fontWeight": [
        "light",
        "regular",
        "medium",
        "semibold",
        "bold",
        "",
        "bolder",
        "boldest"
      ],
      "fontFamily": [
        "",
        "display"
      ],
      "lineHeight": [
        "display-xl",
        "display-lg",
        "display-md",
        "display-sm",
        "display-xs",
        "display-xs-smaller",
        "display-2xs",
        "heading-2xl",
        "heading-xl",
        "heading-lg",
        "heading-md",
        "heading-sm",
        "heading-xs",
        "heading-2xs",
        "paragraph-lg",
        "paragraph-md",
        "paragraph-sm",
        "paragraph-xs",
        "label-lg",
        "label-md",
        "label-sm",
        "label-xs",
        "display-label-lg",
        "display-label-md",
        "display-label-sm"
      ],
      "transitionDelay": [
        "0",
        "75",
        "100",
        "150",
        "200",
        "300",
        "400",
        "500",
        "700",
        "1000",
        "1500"
      ],
      "transitionDuration": [
        "100",
        "200",
        "400",
        "500",
        "1000",
        "1500"
      ],
      "transitionTimingFunction": [
        "linear",
        "ease-in",
        "ease-out",
        "ease-in-out"
      ],
      "size": [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "14",
        "16",
        "20",
        "24",
        "28",
        "32",
        "36",
        "40",
        "44",
        "48",
        "52",
        "56",
        "60",
        "64",
        "72",
        "80",
        "96",
        "px",
        "0-5",
        "1-5",
        "2-5",
        "3-5",
        "4xs",
        "3xs",
        "2xs",
        "xs",
        "sm",
        "base",
        "medium",
        "lg",
        "xl",
        "xl-tap",
        "2xl",
        "3xl",
        "4xl",
        "5xl"
      ],
      "width": [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "14",
        "16",
        "20",
        "24",
        "28",
        "32",
        "36",
        "40",
        "44",
        "48",
        "52",
        "56",
        "60",
        "64",
        "72",
        "80",
        "96",
        "px",
        "0-5",
        "1-5",
        "2-5",
        "3-5",
        "4xs",
        "3xs",
        "2xs",
        "xs",
        "sm",
        "base",
        "medium",
        "lg",
        "xl",
        "xl-tap",
        "2xl",
        "3xl",
        "4xl",
        "5xl"
      ],
      "minWidth": [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "14",
        "16",
        "20",
        "24",
        "28",
        "32",
        "36",
        "40",
        "44",
        "48",
        "52",
        "56",
        "60",
        "64",
        "72",
        "80",
        "96",
        "px",
        "0-5",
        "1-5",
        "2-5",
        "3-5",
        "4xs",
        "3xs",
        "2xs",
        "xs",
        "sm",
        "base",
        "medium",
        "lg",
        "xl",
        "xl-tap",
        "2xl",
        "3xl",
        "4xl",
        "5xl"
      ],
      "maxWidth": [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "14",
        "16",
        "20",
        "24",
        "28",
        "32",
        "36",
        "40",
        "44",
        "48",
        "52",
        "56",
        "60",
        "64",
        "72",
        "80",
        "96",
        "px",
        "0-5",
        "1-5",
        "2-5",
        "3-5",
        "4xs",
        "3xs",
        "2xs",
        "xs",
        "sm",
        "base",
        "medium",
        "lg",
        "xl",
        "xl-tap",
        "2xl",
        "3xl",
        "4xl",
        "5xl"
      ],
      "height": [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "14",
        "16",
        "20",
        "24",
        "28",
        "32",
        "36",
        "40",
        "44",
        "48",
        "52",
        "56",
        "60",
        "64",
        "72",
        "80",
        "96",
        "px",
        "0-5",
        "1-5",
        "2-5",
        "3-5",
        "4xs",
        "3xs",
        "2xs",
        "xs",
        "sm",
        "base",
        "medium",
        "lg",
        "xl",
        "xl-tap",
        "2xl",
        "3xl",
        "4xl",
        "5xl"
      ],
      "minHeight": [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "14",
        "16",
        "20",
        "24",
        "28",
        "32",
        "36",
        "40",
        "44",
        "48",
        "52",
        "56",
        "60",
        "64",
        "72",
        "80",
        "96",
        "px",
        "0-5",
        "1-5",
        "2-5",
        "3-5",
        "4xs",
        "3xs",
        "2xs",
        "xs",
        "sm",
        "base",
        "medium",
        "lg",
        "xl",
        "xl-tap",
        "2xl",
        "3xl",
        "4xl",
        "5xl"
      ],
      "maxHeight": [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "14",
        "16",
        "20",
        "24",
        "28",
        "32",
        "36",
        "40",
        "44",
        "48",
        "52",
        "56",
        "60",
        "64",
        "72",
        "80",
        "96",
        "px",
        "0-5",
        "1-5",
        "2-5",
        "3-5",
        "4xs",
        "3xs",
        "2xs",
        "xs",
        "sm",
        "base",
        "medium",
        "lg",
        "xl",
        "xl-tap",
        "2xl",
        "3xl",
        "4xl",
        "5xl"
      ],
      "spacing": [
        "3xs",
        "2xs",
        "xs",
        "sm",
        "base",
        "md",
        "lg",
        "xl",
        "2xl",
        "3xl",
        "4xl",
        "padding-card-sm",
        "horizontal-button-group",
        "padding-card-md",
        "vertical-card-group",
        "padding-card-lg",
        "vertical-form-group",
        "vertical-button-group",
        "horizontal-margin-mobile",
        "horizontal-margin-tablet",
        "horizontal-card-group",
        "horizontal-icon-to-element"
      ]
    }
  }
}